import type { ReactNode } from "react"

import { Avatar, type AvatarProps } from "@/components/ui/avatar"

import { cx } from "@uui/utils/cx"

/*
 * A staff member with a name and a second line in notation: a photograph when
 * there is one, initials when there is not. `tone="print"` is
 * the rail's foot. No status dot and no verified tick, as the Avatar says.
 */
export type AvatarLabelGroupProps = AvatarProps & {
  title: ReactNode
  subtitle?: ReactNode
  className?: string
}

const TITLE = {
  paper: "text-primary",
  print: "text-stone-50",
}
const SUBTITLE = {
  paper: "notation",
  print: "text-onprint-quiet text-3xs font-mono leading-[1.1]",
}

export function AvatarLabelGroup({
  title,
  subtitle,
  tone = "paper",
  size = "sm",
  className,
  ...avatar
}: AvatarLabelGroupProps) {
  return (
    <span className={cx("flex min-w-0 items-center gap-2.5", className)}>
      <Avatar tone={tone} size={size} {...avatar} />
      <span className="flex min-w-0 flex-col gap-[3px]">
        <span
          className={cx(
            "truncate text-[13px] leading-[1.2] font-semibold",
            TITLE[tone],
          )}
        >
          {title}
        </span>
        {subtitle && (
          <span className={cx("truncate", SUBTITLE[tone])}>{subtitle}</span>
        )}
      </span>
    </span>
  )
}
